import { observer } from "mobx-react-lite";
import { Fragment } from "react";
import { Link } from "react-router-dom";
import { Container, Header, Segment, Image, Button, Divider } from "semantic-ui-react";
import { useStore } from "../../app/stores/store";
import LoginForm from "../users/LoginForm";
import RegisterForm from "../users/RegisterForm";

//import video01 from "../../../public/assets/videos/activitiesHub/video01.mp4";
import video01 from "../../assets/videos/activitiesHub/video01.mp4" // "../../../public/assets/videos/activitiesHub/video01.mp4";
import FacebookLogin from "@greatsumini/react-facebook-login";

//export default function HomePage() {
export default observer(function HomePage() { //' n
    const usStore = useStore(); //' n

    return (
        // <Container style={{marginTop: '7em'}}>
        //     <h1>Home page</h1>
        //     <h3>Go to <Link to='/Activities'>Activities</Link></h3>
        // </Container>

        <Segment inverted textAlign='center' vertical className='masthead'  >
            {/* <video src={'/assets/videos/activitiesHub/video01.mp4'} autoPlay loop  muted  className="video_ " /> */}
            <Container text className="content_x " >
                <Header as='h1' inverted >
                    <Image size='massive' src='/assets/logo.png' alt='logo' style={{marginBottom: 12}} />
                    {usStore.commonStore.appDisplayName}
                </Header>
                {/* <Header as='h2' inverted content={`Welcome to ${usStore.commonStore.appDisplayName}`} /> */}
                {/* <Button as={Link} to='/activities' size='huge' inverted >
                    Go to Activities!
                </Button> */}
                {/* <Button content='Login!' inverted as={Link} to='/login' /> */}
                <Header as='h2' inverted content={`Your Passion. Our Platform.`} />
                {/* <Divider /> */}

                {usStore.userStore.isLoggedIn ? ( //' n
                    <Fragment>
                        {/* <video src={'/assets/videos/activitiesHub/video01.mp4'} width="700" height="400" autoPlay={true} controls /> */}
                        {/* <video src={video01} width="700" height="400" autoPlay={true} loop  controls /> */}

                        {/* <Header as='h2' inverted content={`Welcome to ${usStore.commonStore.appDisplayName}`} /> */}
                        <Button content='Go to Activities!' as={Link} to='/activities' size='huge' inverted />
                    </Fragment>
                ) : ( 
                    // <Button content='Login!' size='huge' inverted as={Link} to='/login' />

                    <Fragment>
                        {/* <Button content='Login!' size='huge' inverted as={Link} to='/login' /> */}
                        <Button content='Login!' size='huge' inverted onClick={() => usStore.modalStore.openModal(<LoginForm />) } />

                        {/* <Button content='Register!' size='huge' inverted onClick={() => usStore.modalStore.openModal(<h1>Register</h1>) } /> */}
                        <Button content='Register!' size='huge' inverted onClick={() => usStore.modalStore.openModal(<RegisterForm />) } />

                        <Divider horizontal inverted>Or</Divider>
                        <Button 
                            content='Login with Facebook' 
                            size='huge' 
                            inverted 
                            color='facebook' 
                            loading={usStore.userStore.facebookLoading}
                            as={FacebookLogin} 
                            appId_Ash='802459211295734' 
                            appId='802459211295734' 
                            //Aiden Greeneson 100088148933690 aiden_ugimuzy_greeneson@tfbnw.net Pa$$w0rd
                            appId_test='1075625066441731' 
                            //appId='1075625066441731' 
                            onSuccess={(response: any) => {
                                console.log('Login success', response);
                                usStore.userStore.facebookLogin(response.accessToken);
                            }}
                            onFail={(response: any) => {
                                console.log('Login failed', response);
                            }}
                        />
                    </Fragment>
                )}

            </Container>
        </Segment>
    )
})